export enum ViewIndex {
	View1 = "view1",
	View2 = "view2",
}
